'use client'
import IconRenderer from "@/libs/contentful/helper/IconRenderer";
import FilterElements from "@/components/ContentElements/News/NewsFilter/FilterElements";
import React, {useState} from "react";
import clsx from "clsx";
import useWindowDimensions from "@/libs/contentful/helper/useWindowDimension";

interface Props {
    contentTagsHeadline: string
    contentTypeHeadline: string
    yearHeadline: string
}

export function NewsFilter({contentTagsHeadline, contentTypeHeadline, yearHeadline}: Props) {
    const [open, setOpen] = useState(false);
    const { width } = useWindowDimensions();
    return (
        <>
            <div
                className={clsx(open ? 'gap-l' : 'gap-[0]', "z-[1] brand-transition flex flex-col md:flex-row md:gap-l items-center justify-center w-full bg-brand-blue sticky top-[0px]")}>
                <button type="button"
                        disabled={width !== undefined && width > 834}
                        onClick={() => setOpen(!open)}
                        aria-pressed={open ? 'true' : 'false'}
                        className="flex items-center gap-xs text-p font-sans md:whitespace-pre-wrap font-bold">
                    <IconRenderer icon="icon-filter" className="" />
                    Filter
                    <IconRenderer icon="icon-chevron-down" className={clsx(open ? "rotate-180" : "", "brand-transition md:hidden")} />
                </button>
                <div className={clsx(open ? "opacity-[1] h-[224px]" : "h-[0] opacity-0 pointer-events-none", "md:h-fit md:opacity-[1] md:pointer-events-auto brand-transition flex flex-col md:flex-row gap-l md:flex-1 w-full")}>
                    <FilterElements contentTagsHeadline={contentTagsHeadline} contentTypeHeadline={contentTypeHeadline} yearHeadline={yearHeadline} />
                </div>
            </div>
        </>
    )
}